import React from "react";

const CardWrapperInput = ({ label, icon, colorIcon, children }) => {
  return (
    <div
      style={{
        display: "flex",
        padding: 12,
        flexDirection: "column",
        gap: 24,
        borderRadius: 8,
        border: "1px solid #E5E5E5",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        <i className={icon} style={{ fontSize: 18, color: colorIcon }}></i>
        <p
          style={{
            fontSize: 14,
            fontWeight: 600,
            margin: 0,
          }}
        >
          {label}
        </p>
      </div>
      {children}
    </div>
  );
};

export default CardWrapperInput;
